import React from 'react';
import ValueCell from './ValueCell';
import { CaptionBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/components/servicesTableCellsStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyle = makeStyles(styles);

interface IDiscountCellProps {
	discount: number;
	subtitle?: string;
	title?: string;
	backgroundColor?: types.newServices.backgroundColor;
}

const DiscountCell = (props: IDiscountCellProps) => {
	const classes = useStyle();
	return (
		<ValueCell
			{...props}
			value={
				<span className={classes.discountCell}>
					<CaptionBold inline disableMargin color="brand-secondary">
						{translate('services.table.fbb.discount', props.discount)}
					</CaptionBold>
				</span>
			}
		/>
	);
};

export default DiscountCell;
